<template>
  <div  class="base-tree">
    <el-tree highlight-current ref="tree"  class="tree" v-bind="$attrs" :indent="0"  v-on="$listeners"></el-tree>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        keywords: ''
      }
    },
    methods: {
      returnRef() {
        return this.$refs.tree

      },
      searchData() {
        this.$emit("search", this.keywords)
      },
      getNode(d) {
        return this.$refs.tree.getNode(d);
      },
      appendNode(d, n) {
        this.$refs.tree.append(d, n);
      },
      setCurrentKey(key) {
        return this.$refs.tree.setCurrentKey(key)
      }
    }
  }
</script>
<style lang="scss" scoped>
  .base-tree /deep/ {
    overflow-y: auto;
    .tree .el-tree-node[tabindex="0"]:after {
      border-top: none;
    }
  }
  //.base-tree /deep/ {
  //  overflow: auto;
  //  background: #fff;
  //  .search-wrap {
  //    margin: 10px 20px;
  //  }
  //  .input-name {
  //    padding-bottom: 20px;
  //  }
  //
  //  .tree-content {
  //    display: flex;
  //    flex: 1;
  //    overflow: hidden;
  //    padding-right: 5px;
  //    &:hover {
  //      .tree-btns {
  //        display: block;
  //      }
  //    }
  //
  //    .tree-name {
  //      flex: 1;
  //      white-space: nowrap;
  //      overflow: hidden;
  //      text-overflow: ellipsis;
  //    }
  //    .tree-btns {
  //      display: none;
  //      i {
  //        margin: 0 4px;
  //        &:hover {
  //          color: #355aff;
  //        }
  //      }
  //    }
  //  }
  //
  //  .tree {
  //    padding-left: 2px;
  //    &.el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
  //      background-color: #fff;
  //      color: #3d9cfc;
  //      font-weight: bold;
  //
  //      .el-tree-node__expand-icon {
  //        color: #3d9cfc;
  //        &.is-leaf {
  //          color: transparent;
  //          width: 0;
  //          padding: 5px;
  //        }
  //      }
  //    }
  //
  //    .el-tree-node__expand-icon.is-leaf {
  //      color: transparent;
  //      width: 0;
  //      padding: 5px;
  //    }
  //
  //    .el-tree-node {
  //      padding-left: 12px;
  //      border-left: 1px solid #e2e3e8;
  //    }
  //    // 根目录不显示指引线
  //    > .el-tree-node:first-child {
  //      border-left: none;
  //      > .el-tree-node__content:first-child {
  //        &::before {
  //          display: none;
  //        }
  //      }
  //    }
  //    // 每一级目录最后一个的拐角
  //    .el-tree-node:last-child {
  //      border-left: none;
  //      position: relative;
  //      &::before {
  //        content: "";
  //        position: absolute;
  //        top: 0;
  //        left: 0;
  //        height: 15px;
  //        width: 1px;
  //        background-color: #e2e3e8;
  //      }
  //    }
  //
  //    .el-tree-node__content {
  //      position: relative;
  //      height: 30px;
  //      &::before {
  //        content: "";
  //        position: absolute;
  //        top: 15px;
  //        left: -12px;
  //        height: 1px;
  //        background-color: #e2e3e8;
  //        width: 15px;
  //      }
  //    }
  //
  //    .el-input-group__append {
  //      background-color: #fff;
  //    }
  //
  //    .el-tree-node__children {
  //      padding-left: 10px;
  //    }
  //    .el-tree-node__expand-icon.expanded {
  //      -webkit-transform: rotate(0deg);
  //      transform: rotate(0deg);
  //    }
  //    .el-icon-caret-right:before {
  //      content: "\e78a";
  //      font-size: 16px;
  //    }
  //
  //    .el-tree-node__expand-icon.expanded.el-icon-caret-right:before {
  //      content: "\e784";
  //      font-size: 16px;
  //    }
  //  }
  //}
</style>
